import React from 'react';
import { MemoryRouter } from 'react-router-dom';
import SidePanelHostProvider from '@/core/deep-dive/contexts/side-panel-provider';
import SidePanel, { SidePanelTab } from '@/core/deep-dive/components/side-panel';
import MobileSidePanel from '@/core/deep-dive/components/mobile/mobile-side-panel';
import useFixedSidePanelWidgets from '@/core/deep-dive/hooks/use-fixed-side-panel-widgets';
import { useIsMobile } from '@/shared/hooks/export';
import { AppHeaderActionsProvider } from '@/core/deep-dive/contexts/app-header-actions-context';

/**
 * `navigationProvider` is the app's widget-navigation provider. It is passed in by the
 * composition root because widget navigation sits above deep-dive and dispatches into it.
 */
export default function SidePanelShell({
  navigationProvider: NavigationProvider,
}: {
  navigationProvider: React.ComponentType<React.PropsWithChildren>;
}) {
  const { deepDiveWidget } = useFixedSidePanelWidgets();
  const isMobile = useIsMobile(768);

  const tabs: SidePanelTab[] = [{ id: 'deep-dive', widget: deepDiveWidget }];

  return (
    <MemoryRouter>
      <SidePanelHostProvider>
        <NavigationProvider>
          <AppHeaderActionsProvider>
            {isMobile ? <MobileSidePanel tabs={tabs} /> : <SidePanel tabs={tabs} />}
          </AppHeaderActionsProvider>
        </NavigationProvider>
      </SidePanelHostProvider>
    </MemoryRouter>
  );
}
